import React from 'react';
import { FadeIn } from './ui/FadeIn';
const steps = [{
  num: '01',
  title: 'Property is scanned',
  desc: 'Our technicians use advanced 3D cameras to capture every inch of the space.'
}, {
  num: '02',
  title: 'Interactive tour is generated',
  desc: 'We process the data into a seamless, high-fidelity digital twin of the property.'
}, {
  num: '03',
  title: 'Clients explore remotely',
  desc: 'Users walk through the property virtually, saving time and making informed decisions.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-32 bg-zinc-950 border-t border-white/5" data-id="element-141">
      <div className="max-w-7xl mx-auto px-6" data-id="element-142">
        <FadeIn className="text-center mb-24" data-id="element-143">
          <h2 className="text-4xl md:text-5xl font-display font-medium text-white" data-id="element-144">
            How it works
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-145">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px bg-white/10" data-id="element-146" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-147">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative flex flex-col items-center text-center" data-id="element-148">
                <div className="w-24 h-24 rounded-full glass-panel flex items-center justify-center text-2xl font-display text-white mb-8 relative z-10 bg-zinc-950" data-id="element-149">
                  {step.num}
                </div>
                <h3 className="text-xl font-medium text-white mb-4" data-id="element-150">
                  {step.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed max-w-xs" data-id="element-151">
                  {step.desc}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}